import { useEffect, useMemo, useState } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import configureAppStore from "./store/ConfigureStore";
import { App } from "./App";
import "./index.css";
import theme from "./styles/mui/theme";
import { GetEnvVariables } from "./utils";
import { loadInsights } from "./utils/logHandlers/appInsight";
import { registerServiceWorker } from "./utils/serviceWorkerRegistration";
import { startVersionCheck } from "./utils/appVersionCheck";
import { IS_LOCALHOST, updateConfigs } from "./constants/Config";
import { AppConfigs } from "./models/AppConfigs";


const store = configureAppStore();
const container = document.getElementById("root")!;
const root = createRoot(container);

const AppWithOutAuthentication = () => {
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);
  const variables = useMemo(
    () => {
      const envVariables = {
        REACT_APP_HPP_HOST_CONFIG_URL_HPPORTAL: "[_CONFIG_URL_HPPORTAL_]",
        REACT_APP_CLIENT_SERVICE_EMAIL: "[_CLIENT_SERVICE_EMAIL_]",
        REACT_APP_HPP_APPINSIGHTS_CONNECTION_STRING: "[_APP_INSIGHTS_CONN_]",
      };
     return IS_LOCALHOST ? GetEnvVariables() : envVariables;
    },
    [],
  );
  useEffect(() => {
    (async () => {
      const resolvedConfig: AppConfigs = {
        REACT_APP_HPP_HOST_CONFIG_URL_HPPORTAL: "",
        REACT_APP_DEBUG: false,
        REACT_APP_CLIENT_SERVICE_EMAIL: "",
        REACT_APP_HPP_APPINSIGHTS_CONNECTION_STRING: "",
        ...(variables as Partial<AppConfigs>),
      };
      updateConfigs(resolvedConfig);
      loadInsights(resolvedConfig.REACT_APP_HPP_APPINSIGHTS_CONNECTION_STRING);
      setIsConfigLoaded(true);
    })();
  }, []);

  return (
    <div>
      {isConfigLoaded ? (
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </Provider>
      ) : (
        <>Loading...</>
      )}
    </div>
  );
};

// Register service worker and start version polling for auto-reload on new deployments
registerServiceWorker();
startVersionCheck();

root.render(<AppWithOutAuthentication />);
